const LicPackageKeys = {
    ADMINISTRATION: "administration",
    ALARM: "alarms",
    CAGE: "cages",
    CHAIN: "chains",
    CLIMATE: "climates",
    COUNTER: "counters",
    DISPENSER_5G: "dispensers5G",
    DISPENSER: "dispensers",
    NUTRI_PRO: "nutriPRO",
    IPSUM: "ipsum",
    PORKER: "porkers",
    SMALL_CAGE: "smallCages",
    SILO: "siloses",
    SOW: "sows",
    FILES: "files",
    OCR: "ocr",
    FARM_MAP: "farmMap",
    FARM_WATCH_PRO: "farmWatchPro"
};

module.exports = LicPackageKeys;
